import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'
import axios from 'axios'

Vue.use(Vuex);

var axios_instance = axios.create({});

const apiv1_endpoint = 'https://api.qdspro.com/v1';

export const store = new Vuex.Store({
	state: {
		user: {
			id:'',
			full_name:'',
			email:'',
			is_logged_in: false,
			credits: {
				credit:0,
				debit:0
			},
			blocked:"no",
			user_type:'',
			signup_datetime:'',
			doubts:[]
		},
		global_loader: false,
		packages:[],
		doubts:[],
		transactions:[]
	},
	getters: {
		user: state => {
			return state.user;
		},
		global_loader: state => {
			return state.global_loader;
		},
		get_packages: state => {
			return state.packages;
		},
		unassigned_doubts: state => {
			var d = _.filter(state.doubts,{'assigned_expert_id':null,'doubt_status':'pending'});
			return d;
		},
		unsolved_doubts: state => {
			var d = _.filter(state.doubts,{'doubt_status':'pending'});
			return d;
		},
		doubts: state => {
			return state.doubts;
		},
		transactions: state => {
			return state.transactions;
		}
	},
	mutations: {
		setToken(state,token) {
			localStorage.setItem('token',token);
			axios_instance.defaults.headers.common['Authorization']='Bearer '+token;
			return true;
		},

		removeToken(state) {
			localStorage.removeItem('token');
		},

		setUser(state, user) {
			for(var property in state.user) {
				
				if(user.hasOwnProperty(property)) {
					state.user[property] = user[property]
				}
			}
		},
		setPackages(state, data) {
			state.packages = data;
		},
		setLoader(state,loading) {
			state.global_loader = loading;

			if(loading) {
				store.commit('disableBodyOverflow');
			} else {
				store.commit('enableBodyOverflow');
			}
		},
		disableBodyOverflow(state) {
			document.body.classList.add('no-overflow');
		},
		enableBodyOverflow(state) {
			document.body.classList.remove('no-overflow');
		},
		setDoubts(state, data) {
			state.doubts = data;
		},
		setTransactions(state, data) {
			state.transactions = data;
		}
	},
	actions: {
		async add_solution(context,data) {
			try {
				const result2 = await axios_instance.post(apiv1_endpoint+'/solutions',data);

				console.log(result2);

				// adding a solution also gets us all the doubts again

				await context.dispatch('fetch_doubts');

				return {
					status:'success'
				};
			} catch (ex) {
				throw Error('Solution could not be added');
			}
		},
		async login(context, data) {
			//required data params
			// email, password.

			console.log('trying to login');

			try {
				
				const result2 = await axios_instance.post(apiv1_endpoint+'/get-token',{
					user_id: data.email,
					password: data.password,
				});

				console.log(result2);

				//console.log(result);

				context.commit('setToken',result2.data.token);

				let user = {
					is_logged_in: true
				}
				context.commit('setUser',user);

				return {
					status:'success'
				};

			} catch(ex) {
				console.log('got error',ex);
				return {
					status:'failure', 
					error:'You have entered incorrect credentials!'
				}
			}
		},
		async logout(context) {
			await context.commit('removeToken');
			context.commit('setUser',{is_logged_in:false});
		},
		async fetch_me(context) {
			try {
				
				const result2 = await axios_instance.get(apiv1_endpoint+'/me');

				context.commit('setUser',result2.data[0]);

			} catch(ex) {
				console.log(ex.toString());
				throw Error('Could not fetch user info')
			
			}
		},
		async fetch_packages(context) {
			try {
				
				const result2 = await axios_instance.get(apiv1_endpoint+'/packages');
				console.log('store',result2);
				context.commit('setPackages',result2.data.data);

			} catch(ex) {
				console.log(ex.toString());
				throw Error('Could not fetch the packages!')
			
			}
		},
		async fetch_doubts(context) {
			try {
				
				const result2 = await axios_instance.get(apiv1_endpoint+'/doubts/assigned');
				
				context.commit('setDoubts',result2.data.data);

			} catch(ex) {
				console.log(ex.toString());
				throw Error('Could not fetch the doubts!')
			
			}
		},
		async fetch_doubt_attachment(context, doubt_id) {
			try {
				
				const result = await axios_instance.get(apiv1_endpoint+'/doubts/'+doubt_id+'/attachment');
				
				return result;

			} catch(ex) {
				console.log(ex.toString());
				throw Error('Could not fetch the attachment for doubt!');
			
			}
		},
		async fetch_doubt_solution(context, doubt_id) {
			try {
				
				const result = await axios_instance.get(apiv1_endpoint+'/doubts/'+doubt_id+'/solution');
				
				return result;

			} catch(ex) {
				console.log(ex.toString());
				throw Error('Could not fetch the solution for doubt!');
			
			}
		},
		async fetch_doubt_solution_attachment(context, doubt_id) {
			try {
				
				const result = await axios_instance.get(apiv1_endpoint+'/doubts/'+doubt_id+'/solution/attachment');
				
				return result;

			} catch(ex) {
				console.log(ex.toString());
				throw Error('Could not fetch the solution attachment!');
			
			}
		},
		async fetch_transactions(context) {
			try {
				
				const result = await axios_instance.get(apiv1_endpoint+'/transactions/');
				
				context.commit('setTransactions', result.data.data);

			} catch(ex) {
				console.log(ex.toString());
				throw Error('Could not fetch the solution attachment!');
			
			}
		}
	}
})


// WEBPACK FOOTER //
// ./src/store/index.js